// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__28C98","inputWrap":"Table_inputWrap__2jK1J","col":"Table_col__1P-HB","bmiTooltip":"Table_bmiTooltip__3rrot"};